import {useFormikContext} from "formik"
import React from "react"
import {countryFilterSearch} from "../../../utility/Helper"
import NavDropdownItem from "../../navigation/desktop/NavDropdownItem"
import Dropdown from "../../reusable/components/Dropdown/Dropdown"
import FormInput, {Color} from "../../reusable/FormInput/FormInput"

interface Props {
  name: string
  label: string
  errors: any
  touched: any
  errColor?: keyof typeof Color
  required?: boolean
  options: any[]
  placeholder?: string
}

const CountrySelectionField: React.FC<Props> = ({
	name,
	label,
	errors,
	touched,
	errColor = Color.dark,
	required,
	placeholder,
	options

}) => {
	const {values, setFieldValue} = useFormikContext()
	const value = values[name]
	const countries = countryFilterSearch(value, options)
		.sort((a, b) => {
			if (a.label < b.label) {
				return -1
			}

			if (a.label > b.label) {
				return 1
			}

			return 0
		})
	const [isOpen, setIsOpen] = React.useState(false)
	const height = countries.length < 3 ? "auto" : 160
	const width = "100%"
	const align = "start"

	return (
		<div className="position-relative">
			<FormInput
				isNewDesign
				placeholder={placeholder}
				name={name}
				label={label}
				errors={errors}
				touched={touched}
				required={required}
				errColor={errColor}
				type="text"
				onFocus={() => setIsOpen(true)}
				onKeyDown={() => setIsOpen(true)}
				onBlur={() => {
					setIsOpen(false)
				}}
				className={"pb-3"}
			/>
			<li style={{zIndex: 12000}}
				className={`position-relative pointer list-unstyled col-auto p-0 ${align === "start" ? "me-4" : "ms-4"} text-bold}`}>

				<Dropdown isOpen={isOpen}
					height={height}
					width={width}
					top={-28}
					left={12}>
					<ul
						className={`bg-white border px-2 py-0 row list-unstyled overflow-auto mb-0 ${countries.length === 0 ? "d-none" : ""}`}
						style={{
							height
						}}>
						{countries.map((country, i) => {
							return <NavDropdownItem key={i}
								label={`${country.label}`}
								action={() => {
									setFieldValue(name, country.label)
									setIsOpen(false)
								}}
								langSwitcher/>
						})}

					</ul>
				</Dropdown>
			</li>

		</div>
	)
}

export default CountrySelectionField

